import { gql } from '@apollo/client'

export const ADD_CRETOR_REQUEST_MUTATION = gql`
  mutation InsertCreator_createCreatorRequest($data: AddCreatorRequestInput!) {
    createCreatorRequest(data: $data) {
      ... on Creator {
        _id
        creatorId
        groupId
        name: title
        provider
        thumbnail
      }

      ... on StatusMessage {
        code
        message
        success
        title
      }
    }
  }
`
